import SlotMachine from '@/components/SlotMachine'

interface SlotPageWrapperProps {
  children?: React.ReactNode
}

const SlotPageWrapper: React.FC<SlotPageWrapperProps> = ({ children }) => {
  return (
    <div className="flex h-screen">
      <div className="bg-themebackground hidden lg:block w-full max-w-[50vw] relative">
        {/* Top white fade overlay */}
        <div
          className="absolute top-0 left-0 w-full h-[50vh] pointer-events-none"
          style={{
            background: 'linear-gradient(to bottom, white 0%, rgba(255,255,255,0) 100%)',
            zIndex: 10,
          }}
        />
        <SlotMachine columns={4} speed={140} />
      </div>

      <div className="bg-customRadial p-7 lg:p-10 flex flex-col gap-10 justify-between items-center w-full lg:w-[50vw] lg:h-screen overflow-y-auto">
        <div className="flex items-center w-full justify-between">
          <div className="flex items-center gap-2">
            <img alt={'CreativeOS'} src={'/whiteCOSVector1.png'} className={'w-6'} />
            <span className="text-white font-bold">CreativeOS</span>
          </div>
        </div>
        <div className="flex flex-col items-center bg-themebackground p-7 gap-5 rounded-xl lg:min-w-[35rem]">
          {children}
        </div>
        <div className="flex items-center w-full justify-between">
          <div className="flex items-center gap-2">
            <span className="text-white font-bold opacity-0">CreativeOS</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SlotPageWrapper
